export default __webpack_public_path__ + "static/media/ai.7106d0c0.png";